









import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'Drafts'
})
export default class extends Vue {}
